import { ChatMessageModel } from '../client/SmartAssistantBackendClient';

const stripHtml = (value: string) => value.replace(/<[^>]+>/g, '');

const tryExtractJsonContent = (value: string): string | null => {
  const trimmed = value.trim();
  if (!trimmed.startsWith('{') || !trimmed.includes('"content"')) return null;
  try {
    const parsed = JSON.parse(trimmed);
    if (parsed && typeof parsed.content === 'string') {
      return parsed.content;
    }
  } catch {
    return null;
  }
  return null;
};

export function extractContentText(value: any): string {
  if (!value) return '';
  if (typeof value === 'string') {
    const extracted = tryExtractJsonContent(value);
    return extracted ?? value;
  }
  if (Array.isArray(value)) {
    return value.map(part => {
      if (typeof part === 'string') return part;
      if (typeof part?.text === 'string') return part.text;
      return extractContentText(part?.text ?? part?.content ?? '');
    }).join('');
  }
  if (typeof value === 'object') {
    if (typeof value.text === 'string') return value.text;
    if (Array.isArray(value.text)) return extractContentText(value.text);
    if (value.delta) return extractContentText(value.delta.content ?? value.delta);
    if (value.choices?.[0]?.delta) return extractContentText(value.choices[0].delta.content ?? value.choices[0].delta);
    if (value.content) return extractContentText(value.content);
  }
  return '';
}

export function normalizeMessages(items: any[]) {
  return (items ?? []).map(m => {
    const content = m?.content !== undefined ? extractContentText(m.content) : m?.content;
    return ChatMessageModel.fromJS({ ...m, content });
  });
}

export function unwrapMsgEnvelope(payload: any) {
  if (!payload || typeof payload !== 'object') return payload;
  const msg = (payload as any).msg;
  if (msg) {
    if (typeof msg !== 'object') {
      return {
        ...payload,
        content: payload.content ?? msg,
      };
    }
    return {
      ...msg,
      ...payload,
      chatId: payload.chatId ?? msg.chatId,
      seq: payload.seq ?? msg.seq,
      content: payload.content ?? msg.content ?? msg.text ?? msg.delta ?? msg.choices,
    };
  }
  if (payload.data) return payload.data;
  if (payload.payload) return payload.payload;
  if (payload.message) return payload.message;
  return payload;
}

export function deriveTitle(msgs: ChatMessageModel[]) {
  const firstUser = msgs.find(m => m.role === 'user' && m.content);
  const title = firstUser?.content ? stripHtml(firstUser.content) : '';
  if (!title) return 'Neuer Chat';
  return title.length > 60 ? `${title.slice(0, 60)}...` : title;
}
